var map = {
	"./images/creasit-marker.png": 774,
	"./images/custom-marker.png": 911,
	"./images/icon-address.svg": 551,
	"./images/icon-location.svg": 425,
	"./images/icon-target.svg": 672,
	"./images/layers-2x.png": 541,
	"./images/layers.png": 796,
	"./images/marker-icon-2x.png": 847,
	"./images/marker-icon.png": 871,
	"./images/marker-shadow.png": 76,
	"./images/marker.svg": 686,
	"./images/osm.png": 418,
	"./images/satellite.png": 402,
	"./images/spritesheet.svg": 856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 836;